/* eslint-disable @typescript-eslint/no-explicit-any */
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'

import tariffMenuOptionDE from './tariffsMenuOptionDE.gif'
import tariffMenuOptionEN from './tariffsMenuOptionEN.gif'

import assignTariffGifDE from './assignTariffGifDE.gif'
import assignTariffGifEN from './assignTariffGifEN.gif'

import chargingCardsMenuGifDE from './chargingCardsMenuGifDE.gif'
import chargingCardsMenuGifEN from './chargingCardsMenuGifEN.gif'

import linkChargingCardMenuStepGifEN from './linkChargingCardMenuStepGifEN.gif'
import linkChargingCardMenuStepGifDE from './linkChargingCardMenuStepGifDE.gif'

interface UseGetLanguageMapper {
  assignTariffGif: string
  chargingCardMenuGif: string
  linkChargingCardMenuGif: string
  tariffMenuOptionGif: string
}

export const useGetLanguageMapperGif = (): UseGetLanguageMapper => {
  const { selectedAppLanguage } = useCustomTranslation()
  const tariffMenuOptionGifMapper: Record<string, string> = {
    en: tariffMenuOptionEN,
    de: tariffMenuOptionDE,
    nl: tariffMenuOptionDE,
  }

  const assignTariffGifMapper: Record<string, string> = {
    en: assignTariffGifEN,
    de: assignTariffGifDE,
    nl: assignTariffGifDE,
  }

  const chargingCardMenuGifMapper: Record<string, string> = {
    en: chargingCardsMenuGifEN,
    de: chargingCardsMenuGifDE,
    nl: chargingCardsMenuGifDE,
  }

  const linkChargingCardMenuGifMapper: Record<string, string> = {
    en: linkChargingCardMenuStepGifEN,
    de: linkChargingCardMenuStepGifDE,
    nl: linkChargingCardMenuStepGifDE,
  }

  return {
    assignTariffGif: assignTariffGifMapper[selectedAppLanguage],
    chargingCardMenuGif: chargingCardMenuGifMapper[selectedAppLanguage],
    linkChargingCardMenuGif: linkChargingCardMenuGifMapper[selectedAppLanguage],
    tariffMenuOptionGif: tariffMenuOptionGifMapper[selectedAppLanguage],
  }
}
